import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { resolveTitle } from "config/page-titles";
import { usePageTitleOverride } from "context/PageTitleProvider";

/**
 * Writes `document.title` on every client-side navigation.
 *
 * Prefers a page-set override (e.g. an entity-specific detail title), but ONLY
 * when that override belongs to the current pathname — this guards against a
 * stale title leaking onto the next page after navigation. Falls back to the
 * static title resolved from `config/page-titles`.
 */
export function useDocumentTitle(): void {
  const { pathname } = useLocation();
  const { override } = usePageTitleOverride();

  useEffect(() => {
    document.title =
      override?.pathname === pathname
        ? override.formattedTitle
        : resolveTitle(pathname);
  }, [pathname, override]);
}

export default useDocumentTitle;
